export default __webpack_public_path__ + "static/media/3693.44b34023.png";